import $ from 'jquery';

$('.toolbar-menu__link').on('focus', function(e) {
    $(this).closest('.toolbar__item--container').addClass('toolbar__item--focus');
});

$('body *:not(.toolbar-menu__link)').on('focus', function(e) {
    $('.toolbar__item--container').removeClass('toolbar__item--focus');
});
